import api from "api";

const participants = {
    list: (slug, page, params) => {
        return api().get(`/events/detail/${slug}/participants?page=${page}`, {params: params})
    },
    
    download: (payload) => {
        return api().get(`/exports/participants?event_id=${payload}`, 
        {
            headers: {
                'Accept': 'text/csv',
                'Content-Type': 'text/csv'
            },
            // responseType: 'blob',
            // responseType: 'arraybuffer',
        }
        )
    }
}

export default participants;